module.exports = __webpack_public_path__ + "img/pckk-logo.307968eb.png";